import type TauriDatabase from "@tauri-apps/plugin-sql";
import { type Database as BunDatabase } from "bun:sqlite";

import { runGetTableXInfo } from "./runGetTableXInfo";

/**
 * Checks if a table exists in the database.
 * @param db The database connection (either Bun's SQLite or Tauri's SQL plugin)
 * @param tableName The name of the table to check
 * @returns true if the table exists, false otherwise
 */
export async function runCheckTableExists(
	db: BunDatabase | TauriDatabase,
	tableName: string
): Promise<boolean> {
	try {
		const tableInfo = await runGetTableXInfo(db, tableName);
		// If PRAGMA table_xinfo returns no columns, the table doesn't exist
		return tableInfo.columns.length > 0;
	} catch {
		// If runGetTableXInfo throws an error, the table doesn't exist
		return false;
	}
}
